module.exports = __webpack_public_path__ + "img/f-thermometer-img8-3.30b16622.png";